const fields = {
  config: { columns: 1 },
  fields: [
    {
      name: 'checkinInstruction',
      label: 'Instrukcja zameldowania',
      column: 1,
      type: 'textarea'
    },
    {
      name: 'rules',
      label: 'Zasady pobytu',
      column: 1,
      type: 'checkGroup',
      dictionary: 'rule',
      singleGroup: true
    },
    {
      name: 'googleMapsUrl',
      label: 'URL lokalizacji na google maps',
      column: 1,
      type: 'textarea',
      trick: 'Skopiuj wartość z atrybutu src w kodzie iframe wygenerowanym przez Mapy Google.'

    },
    {
      name: 'googleMapsMailUrl',
      label: 'URL lokalizacji w mailu',
      column: 1,
      trick: 'Po prostu skopiuj link do lokalizacji z Google Maps i wklej go tutaj.',
      type: 'textarea'
    },
    {
      name: 'integrations',
      type: 'component',
      title: 'Integracje',
      config: { columns: 1 }
    },
    {
      name: 'bookingCalendarUrl',
      label: 'URL kalendarza Booking.com',
      column: 1,
      trick: 'Aby usunąć URL kalendarza Booking.com, wyczyść pole i zapisz.',
      type: 'textarea',
      component: 'integrations'

    }
  ]
};

export default fields;
